.backButton {
  position: absolute;
  top: 94px;
  left: -66px;
  display: none;
  place-items: center;
  width: 40px;
  height: 40px;
  border: 1px solid rgb(0 0 0 / 12%);
  border-radius: 100%;

  &:disabled {
    cursor: default;
  }

  &:hover:not(:disabled) {
    background-color: rgb(0 0 0 / 5%);
  }
}

.pressReleaseRoot {
  @container press-release-root (min-width: 1024px) {
    display: grid;
  }
}

.screen {
  @media screen and (width >= 1024px) {
    display: grid;
  }
}
